import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./App.scss";
import { getFromStorage, STORAGE_KEYS } from "./constants";
import Routing from "./Routes";
import { firebaseCloudMessaging } from "./utils/firebase";
import LanguageContextProvider from "./context/Language";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // Calls the getMessage() function if the token is there
    async function setToken() {
      try {
        const fcmToken = await firebaseCloudMessaging.init();
        if (fcmToken) {
          console.log("fcm_Token", fcmToken);
        }
      } catch (error) {
        console.log(error);
      }
    }

    setToken();
    // Event listener that listens for the push notification event in the background
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        try {
          event?.source?.postMessage("Hi client");
          console.log("event for the service worker", event);
          return toast(
            <div style={{ height: "100%" }}>
              <div>{event?.data?.notification?.title}</div>
              <div>{event?.data?.notification?.body}</div>
            </div>
          );
          return event;
        } catch (e) {
          console.log(e, "error");
          return e;
        }
      });
    }

    return () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", (e) =>
          console.log(e)
        );
      }
    };
  }, []);

  useEffect(() => {
    const handleValidationScroll = () => {
      setTimeout(() => {
        const errorField = document.querySelector(
          ".MuiFormControl-root:has(.MuiFormHelperText-root), .MuiGrid-item:has(.err_msg), div:has(.err_msg)"
        );
        if (errorField) {
          errorField.scrollIntoView({ behavior: "smooth", block: "center" });
          const input = errorField.querySelector("input, textarea, select") as HTMLElement;
          if (input) {
            input.focus({ preventScroll: true });
          }
        }
      }, 150);
    };

    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const button = target.closest("button, input[type='button'], input[type='submit']");
      if (button) {
        handleValidationScroll();
      }
    };

    document.addEventListener("submit", handleValidationScroll);
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("submit", handleValidationScroll);
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return(
    <LanguageContextProvider>
    <Routing />
    </LanguageContextProvider>
  )

   ;
}

export default App;
